import React from 'react';
import { useBannerContext } from '@homeexchange/navigation-bar';

const BannerBodyClassSync = () => {
    const { hasBanner, bannerHeight } = useBannerContext();

    React.useEffect(() => {
        if (hasBanner) {
            document.body.classList.add('has-communication-banner');
        } else {
            document.body.classList.remove('has-communication-banner');
        }
        document.body.style.setProperty('--communication-banner-height', `${bannerHeight}px`);

        return () => {
            document.body.classList.remove('has-communication-banner');
            document.body.style.removeProperty('--communication-banner-height');
        };
    }, [hasBanner, bannerHeight]);

    return null;
};

export default BannerBodyClassSync;
